import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {editor} from "@/app/editor";
import {GroupModuleV1} from "@/app/editor/modules/group/v1/index";
import GroupProductsTableView from "@/app/editor/modules/group/v1/view/GroupProductsTableView.vue";
import ValidInputNumber from "@/app/editor/modules/group/v1/view/ValidInputNumber.vue";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import {watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupStepPrice',
  props: {
    index: {}
  },
  setup(__props: any) {

const props = __props
const group = editor.activity?.modules[props.index] as GroupModuleV1

watch(() => group.config.steps[0], (i) => group.config.steps.forEach(ii => ii.items = i.items), {deep: true})


return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_table_column = _resolveComponent("a-table-column")!
  const _component_a_table_column_group = _resolveComponent("a-table-column-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell")!
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlockContentBox, null, {
      default: _withCtx(() => [
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("库存数量")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_number, {
              placeholder: "点击输入库存数量",
              max: 9999,
              min: 1,
              "addon-after": "个",
              value: _unref(group).config.goods.stock,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(group).config.goods.stock) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemKey, null, {
          default: _withCtx(() => [
            _createTextVNode("团长免单")
          ]),
          _: 1
        }),
        _createVNode(BlockContentItemValue, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_switch, {
              checked: _unref(group).config.goods.leader_free,
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_unref(group).config.goods.leader_free) = $event))
            }, null, 8, ["checked"]),
            _hoisted_1,
            _createVNode(_component_a_typography_text, { type: "secondary" }, {
              default: _withCtx(() => [
                _createTextVNode("开启后只有最高阶梯成团，团长才免单，系统不处理免单，店家自行处理 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      "data-source": _unref(group).config.steps,
      bordered: "",
      pagination: false
    }, {
      summary: _withCtx(() => [
        _createVNode(_component_a_table_summary_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_table_summary_cell, { "col-span": 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  disabled: _unref(group).config.steps.length>=4,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(group).config.steps.push({total_value: 0,group_size: _unref(group).config.steps.last()?.group_size+2 ?? 0,items: _unref(group).config.steps.last()!.items ,price:  0})))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 添加价格阶梯 ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      bodyCell: _withCtx(({ column, record, index }) => [
        (column.key === 'step')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ], 64))
          : (column.key==='size')
            ? (_openBlock(), _createBlock(ValidInputNumber, {
                key: 1,
                value: record.group_size,
                "onUpdate:value": ($event: any) => ((record.group_size) = $event),
                max: 19,
                min: 2,
                onChange: () => {_unref(group).config.steps.forEach((i,k) => {if (k> index) i.group_size = 0})},
                valid: v => index>0 ? _unref(group).config.steps[index-1].group_size>=v ? '成团人数必须高于上一阶梯' : null : null
              }, null, 8, ["value", "onUpdate:value", "onChange", "valid"]))
            : (column.key==='sell_price')
              ? (_openBlock(), _createBlock(ValidInputNumber, {
                  key: 2,
                  placeholder: "点击输入定金",
                  max: 999,
                  min: 0.1,
                  value: _unref(group).config.goods.sell_price,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(group).config.goods.sell_price) = $event)),
                  valid: v => v <= 0 ? '未设置' : _unref(group).config.steps.reduce((a, b) => (a > 0 && a < b.price ? a : b.price), 0) <= v ? '不得高于团购价' : null
                }, null, 8, ["value", "valid"]))
              : (column.key==='price')
                ? (_openBlock(), _createBlock(ValidInputNumber, {
                    key: 3,
                    value: record.price,
                    "onUpdate:value": ($event: any) => ((record.price) = $event),
                    max: 99999,
                    onChange: () => {_unref(group).config.goods.sell_price = 0; _unref(group).config.steps.forEach((s,i) => {if(i>index) {s.price=0}})},
                    valid: v => v < 10 ? '未设置' : v < _unref(group).config.goods.sell_price ? '不得低于定金价' : index>0 ? _unref(group).config.steps[index-1].price <= v ? `团购价必须逐级递减` : null : null
                  }, null, 8, ["value", "onUpdate:value", "onChange", "valid"]))
                : (column.key==='balance')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createTextVNode(_toDisplayString(record.price - _unref(group).config.goods.sell_price), 1)
                    ], 64))
                  : (column.key==='opt')
                    ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                        key: 5,
                        title: "确定删除么？",
                        disabled: _unref(group).config.steps.length<=2,
                        onConfirm: () => _unref(group).config.steps.splice(index,1)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            danger: "",
                            type: "default",
                            disabled: _unref(group).config.steps.length<=2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("删除")
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onConfirm"]))
                    : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table_column_group, null, {
          title: _withCtx(() => [
            _createTextVNode("价格阶梯设置")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_table_column, {
              title: "价格阶梯（最多4阶）",
              key: "step"
            }),
            _createVNode(_component_a_table_column, {
              title: "成团人数",
              key: "size"
            }),
            _createVNode(_component_a_table_column, {
              title: "团购价（元）",
              key: "price"
            }),
            _createVNode(_component_a_table_column, {
              title: "参团定金（元）",
              key: "sell_price",
              "custom-cell": (r,i) => ({rowSpan:!i ? _unref(group).config.steps.length: 0})
            }, null, 8, ["custom-cell"]),
            _createVNode(_component_a_table_column, {
              title: "到店补尾款（元）",
              key: "balance"
            }),
            _createVNode(_component_a_table_column, {
              title: "操作",
              key: "opt"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(GroupProductsTableView, {
      items: _unref(group).config.steps[0].items,
      "onUpdate:items": _cache[4] || (_cache[4] = ($event: any) => ((_unref(group).config.steps[0].items) = $event))
    }, null, 8, ["items"]),
    _createVNode(GroupProductsTableView, {
      items: _unref(group).config.fail_items,
      "onUpdate:items": _cache[5] || (_cache[5] = ($event: any) => ((_unref(group).config.fail_items) = $event)),
      "is-fail": ""
    }, null, 8, ["items"])
  ], 64))
}
}

})